import { useRouterExtended } from "@/global/hooks/useRouterExtended";
import { routes } from "@/global/routes";
import {
  ModalActionButton,
  ModalActionButtonProps,
} from "@/shared/base/components/ModalActionButton/ModalActionButton";
import React from "react";

export const TransferTicketButton = (
  props: ModalActionButtonProps & {
    eventCode: string;
    orderNumber: number;
  }
) => {
  const router = useRouterExtended();
  const { eventCode, orderNumber, ...buttonProps } = props;
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await router.push({
      pathname: routes.ticket_transfer,
      query: {
        ...router.query,
        eventCode,
        orderNumber,
      },
    });
    setIsLoading(false);
  };

  return (
    <ModalActionButton
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={handleClick}
      size="large"
      {...buttonProps}
    >
      Transfer Tickets
    </ModalActionButton>
  );
};
